import { render, staticRenderFns } from "./FilePicker.vue?vue&type=template&id=6cb1f3fb&scoped=true&"
import script from "./FilePicker.vue?vue&type=script&lang=js&"
export * from "./FilePicker.vue?vue&type=script&lang=js&"
import style0 from "./FilePicker.vue?vue&type=style&index=0&id=6cb1f3fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb1f3fb",
  null
  
)

export default component.exports